<template>
  <div>
    <v-stepper-step :complete="current > step" :step="step" :editable="!!ground" color="success" :id="`project-step-${step}`">
      Quel est le type de sol ? <span class="overline">{{ground}}</span>
    </v-stepper-step>

    <v-stepper-content :step="step">
      <v-card color="grey lighten-4" class="mb-6" min-height="200px">
        <v-row>
          <v-col cols="6" class="md-3">
              <v-radio-group v-model="ground" column @change="$emit('change', ground)">
              <v-radio label="Sableux" value="sableux"></v-radio>
              <v-radio label="Argileux" value="argileux"></v-radio>
              <v-radio label="Calcaire" value="calcaire"></v-radio>
              <v-radio label="Terreau (jardinière)" value="terreau"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="6">
            <v-img :src="require('../../assets/form/ground.png')" contain height="180px"/>
          </v-col>
        </v-row>

        <v-card-actions v-if="!!ground">
          <v-btn color="success" @click="$emit('change', ground)" >Suivant</v-btn>
        </v-card-actions>
      </v-card>
    </v-stepper-content>
  </div>
</template>

<script>
export default {
  model: { prop: 'data', event: 'change' },
  props: {
    data: String,
    step: Number,
    current: Number
  },
  data: () => ({
    ground: ''
  }),
  beforeMount () {
    this.ground = this.data
  }
}
</script>